import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { useAuthStore } from './stores/authStore.ts'

Sentry.init({
  dsn: 'https://226dc59e2140faa16c0dac784b9ae1cd@o4510780011577344.ingest.us.sentry.io/4510780689416192',
  sendDefaultPii: true,
  enableLogs: true,
  integrations: [
    // Automatically capture console.error and console.warn as logs
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration(),
  ],
  // Set sample rate for performance monitoring (1.0 = 100% of transactions)
  tracesSampleRate: 1.0,
})

useAuthStore.subscribe((state, previousState) => {
  const userId = state.user?.id
  if (userId === previousState.user?.id) {
    return
  }

  Sentry.setUser(userId ? { id: userId } : null)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
